import {createContext, useContext, useEffect} from 'react';
import {useConfig} from "./config.ctx";
import {useLocation} from 'react-router-dom';

const GoogleTagManagerContext = createContext({});
export const GoogleTagManagerProvider = ({children}) => {
  const { getConfigValue } = useConfig();
  const gtmId = getConfigValue('gtmId');
  const gtmEnabled = getConfigValue('gtmEnabled') || false;
  const location = useLocation();

  useEffect(() => {
    if (gtmId && gtmEnabled && !window.dataLayer) {
      // Define dataLayer array
      window.dataLayer = [];

      /* eslint-disable */
      // Google Tag Manager
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start':
              new Date().getTime(), event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', gtmId);
      /* eslint-enable */
    }
  }, []);

  useEffect(()=> {
    if (gtmEnabled && window.dataLayer) {
      sendPageView();
    }
  }, [location])


  const getGtmSnippetNoScript = () => {
    return {
      __html: `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
                    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`
    };
  }


  const sendPageView = () => {
    window.dataLayer.push({
      'event': 'page_view',
      'page_current_path' : window.location.href,
      'is_global': 'yes',
      'is_directorates': 'no',
      'is_satellite': 'yes'
    })
  }

  const pushGtmEvent = (event, payload) => {
    if (!gtmEnabled || !window.dataLayer) {
      return;
    }
    window.dataLayer.push({...payload, event});
  }

  const value = {pushGtmEvent};

  return (
      <GoogleTagManagerContext.Provider value={value}>
        <div className="google-tag-manager">
          <div className="google-tag-manager__noscript" dangerouslySetInnerHTML={getGtmSnippetNoScript()}/>
        </div>
        {children}
      </GoogleTagManagerContext.Provider>
  );
}

export const useGoogleTagManager = () => useContext(GoogleTagManagerContext);
